<input
	#filterInput
	class="th-filter-input"
	#trigger="matAutocompleteTrigger"
	[class.is-filtered]="selectedValues().length > 0"
	(click)="openPanel(trigger, $event)"
	(focus)="openPanel(trigger)"
	(blur)="onInputBlur()"
	[value]="displayValue()"
	(input)="setSearchValue($any($event.target).value)"
	[placeholder]="
		(inputFocused() ? 'database_view.filters.placeholder_search' : 'database_view.filters.placeholder_select')
			| transloco
	"
	[matAutocomplete]="singleFilterAuto"
	[matAutocompleteDisabled]="disabled()"
	[disabled]="disabled()"
/>

<mat-autocomplete
	#singleFilterAuto="matAutocomplete"
	class="database-multi-select-filter-panel"
	[panelWidth]="'auto'"
	[displayWith]="emptyAutocompleteDisplay"
	[autoActiveFirstOption]="true"
	(opened)="onPanelOpened()"
	(closed)="onPanelClosed()"
>
	<div class="multi-select-options">
		@for (option of filteredOptions(); track option) {
			<!-- The selection state belongs on the option itself: a role="option" inside a combobox popup is
		     what screen readers announce via aria-activedescendant, and a nested widget in there would
		     neither be reachable nor announced. -->
			<mat-option [value]="option" [attr.aria-checked]="isOptionSelected(option)">
				<!-- Toggle from the row and stop the event before mat-option can close the panel. -->
				<div
					class="multi-option-content"
					role="presentation"
					(mousedown)="keepInputFocused($event)"
					(click)="toggleOption(option, $event)"
				>
					<!-- Decorative checkbox; the row handles mouse clicks and Enter toggles via the trigger. -->
					<span class="multi-option-checkbox" aria-hidden="true" (mousedown)="keepInputFocused($event)">
						<mat-icon class="multi-option-icon">{{
							isOptionSelected(option) ? 'check_box' : 'check_box_outline_blank'
						}}</mat-icon>
					</span>
					<span class="multi-option-label" [matTooltip]="labelFor(option)" [matTooltipShowDelay]="500">{{
						labelFor(option)
					}}</span>
				</div>
			</mat-option>
		}
	</div>
	<div class="multi-select-footer" (mousedown)="keepInputFocused($event)">
		<div class="multi-select-bulk-actions">
			<lvr-button
				variant="secondary"
				[label]="'database_view.filters.select_all' | transloco"
				[disabled]="!canSelectAll()"
				(clicked)="$event.stopPropagation(); selectAll()"
			></lvr-button>
			<lvr-button
				variant="secondary"
				[label]="'database_view.filters.clear_all' | transloco"
				[disabled]="!canClearAll()"
				(clicked)="$event.stopPropagation(); clearAll()"
			></lvr-button>
		</div>
		<div class="multi-select-action-row">
			@if (selectedCount() > 0) {
				<span class="multi-select-selected-count">{{
					'database_view.filters.selected_count' | transloco: { count: selectedCount() }
				}}</span>
			}
			<lvr-button
				class="multi-select-apply"
				variant="primary"
				[label]="'database_view.filters.apply' | transloco"
				[loading]="applying()"
				[loadingLabel]="'database_view.filters.applying' | transloco"
				[disabled]="!canApply()"
				(clicked)="$event.stopPropagation(); apply()"
			></lvr-button>
		</div>
	</div>
</mat-autocomplete>
